import { render, staticRenderFns } from "./projectStatus.vue?vue&type=template&id=6d1dbec4&"
import script from "./projectStatus.vue?vue&type=script&lang=js&"
export * from "./projectStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports